module.exports = __webpack_public_path__ + "img/GH-kyujin-top-pa001.a75fc8f3.webp";